export enum FlowParameterType {
	APIKey = 1,
	Passphrase = 2,
	Variable = 3,
	KeyFile = 4,
}
